import React from "react";

type RadioProps = {
  id: string;
  name: string;
  label: string;
  value: string;
  defaultChecked?: boolean;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  ariaDescribedBy?: string;
};

const Radio = ({
  id,
  name,
  label,
  value,
  checked,
  defaultChecked,
  onChange,
  onBlur,
  ariaDescribedBy,
}: RadioProps) => (
  <>
    <label className={`inline-flex items-center mr-2`}>
      <input
        type="radio"
        className="form-radio h-5 w-5 text-steel-blue-600 focus:outline focus:outline-offset-2 focus:outline-2 focus:outline-black/80"
        name={name}
        defaultChecked={defaultChecked}
        value={value}
        checked={checked}
        onChange={onChange}
        onBlur={onBlur}
        id={id}
        aria-describedby={ariaDescribedBy}
      />
      <span className="ml-2">{label}</span>
    </label>
  </>
);

export default Radio;
